import styled from 'styled-components';
import { onSurface, onSurfaceVariant, primary, radiusFull, surface, surfaceHigh } from './themeTokens';

export const ModelViewerModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: max(8px, env(safe-area-inset-top)) max(8px, env(safe-area-inset-right))
    max(8px, env(safe-area-inset-bottom)) max(8px, env(safe-area-inset-left));
  background: rgba(0, 0, 0, 0.85);
`;

export const ModelViewerModalHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  width: min(90vw, 100%);
`;

export const ModelViewerModalContent = styled.div`
  position: relative;
  width: min(90vw, 100%);
  height: min(80vh, calc(100dvh - 96px));
  border-radius: ${({ theme }) => theme.borderRadius?.medium || '1rem'};
  overflow: hidden;
  background: ${surface};

  canvas {
    display: block;
    width: 100% !important;
    height: 100% !important;
  }
`;

export const ModelViewerModalClose = styled.button`
  width: 36px;
  height: 36px;
  border-radius: ${radiusFull};
  border: none;
  background: ${surfaceHigh};
  color: ${onSurface};
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: filter 0.15s;

  &:hover {
    filter: brightness(1.15);
  }

  &:focus-visible {
    outline: 2px solid ${primary};
    outline-offset: 2px;
  }
`;

export const ModelViewerHint = styled.div`
  font-size: 11px;
  color: ${onSurfaceVariant};
  text-align: center;
  max-width: min(90vw, 100%);
`;
